import { useState } from 'react';
import { TableRow, TableCell, MenuItem, Stack } from '@mui/material';
// @types
import { TableMoreMenu } from 'src/components/table';
import Iconify from 'src/components/Iconify';
import { MCQQuestion, QuestionAnswer } from 'src/@types/Course';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
type Props = {
  row: any;
  selected: boolean;
  onEditRow: VoidFunction;
  onDeleteRow: VoidFunction;
  onGoUp: () => void;
  onGoDown: () => void;
  isFirst: boolean;
  isLast: boolean;
};

export default function SectionTableItemRow({
  row,
  selected,
  onEditRow,
  onDeleteRow,
  isFirst,
  isLast,
  onGoDown,
  onGoUp,
}: Props) {

  const { title, details, points, duration } = row;

  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  const getPoints = () => {
    let point = 0;
    row?.details?.questions?.map((quistion: MCQQuestion) => {
      quistion?.answers?.map((answer: QuestionAnswer) => {
        if (answer.correct) point = point + 1;
      });
    });
    return point;
  };
  return (
    <TableRow hover selected={selected}>
      <TableCell align="left"> {title}</TableCell>
      <TableCell align="left"> {details?.type}</TableCell>
      <TableCell align="left"> {points ?? getPoints()}</TableCell>
      <TableCell align="left"> {duration}</TableCell>
      <TableCell align="right">
        <Stack direction="row" alignItems="center" justifyContent={'end'} spacing={2}>
          {!isFirst && <ArrowCircleUpIcon onClick={onGoDown} sx={{ cursor: 'pointer' }} />}
          {!isLast && <ArrowCircleDownIcon onClick={onGoUp} sx={{ cursor: 'pointer' }} />}
          <TableMoreMenu
            open={openMenu}
            onOpen={handleOpenMenu}
            onClose={handleCloseMenu}
            actions={
              <>
                <MenuItem
                  onClick={() => {
                    onEditRow();
                    handleCloseMenu();
                  }}
                >
                  <Iconify icon={'eva:edit-fill'} />
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    onDeleteRow();
                    handleCloseMenu();
                  }}
                  sx={{ color: 'error.main' }}
                >
                  <Iconify icon={'eva:trash-2-outline'} />
                  Delete
                </MenuItem>
              </>
            }
          />
        </Stack>
      </TableCell>
    </TableRow>
  );
}
